// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__wA64k","checkboxCol":"Table_checkboxCol__38dEc","emailCol":"Table_emailCol__1x8Zu","actionCol":"Table_actionCol__1DaVW"};